// import Preload from '../libs/preload-it'
import { counterAnimation } from "./counter";


// Preloadをインスタンス化
// const preload = new Preload()

// ローディング監視するファイルを追加する。 not で外部リソースを否定しないと、CORS制約で読み込みが停止する。
// const $assets = document.querySelectorAll('[src]:not([src*="unpkg.com"]):not([src*="youtube.com"]):not([src*="googletagmanager.com"]):not([src*="google-analytics.com"]):not(.wp-embedded-content)[src]:not([src*="typekit.net"]):not([src*="jquery.com"]):not(#wp-block-library-css):not(#classic-theme-styles-css)')

// const data     = []
const DOM      = {}
      DOM.html    = document.documentElement
      DOM.loading = document.getElementById('js-loading')
      DOM.bar     = document.getElementById('js-bar').querySelector('._bar')

// Array.prototype.forEach.call($assets, $asset => {
//   const url = $asset.src || $asset.href
//   console.log(url)
//   if (data.indexOf(url) == -1) {
//     data.push($asset.src || $asset.href)
//   }
// })

// console.log($assets)
// console.log(data)
// preload.fetch(data)

// preload.onprogress = event => {
// 	DOM.bar.style.width = event.progress + '%'
// }

// // 読み込み完了時のイベント
// preload.oncomplete = () => {
// 	requestAnimationFrame(() => {
// 		requestAnimationFrame(() => {
      
// 		})
// 	})
// }


window.addEventListener('load', () => {
  // document.documentElement.classList.add( 'complete' )
  DOM.bar.style.width = '100%'

	setTimeout( function() {

    DOM.html.classList.add('complete')
    DOM.loading.classList.add('is-complete')

    counterAnimation()
	}, 800 );
}, false)

